import { render, staticRenderFns } from "./wb-header-logo.vue?vue&type=template&id=6c1d985c&scoped=true"
import script from "./wb-header-logo.vue?vue&type=script&lang=js"
export * from "./wb-header-logo.vue?vue&type=script&lang=js"
import style0 from "./wb-header-logo.vue?vue&type=style&index=0&id=6c1d985c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1d985c",
  null
  
)

export default component.exports